// R1-Korrektur (2026-05-20): InfraX-Daten duerfen ins Cockpit
// (Umsaetze, Forderungen, BWA, Steuern, Eingangsrechnungen). Der
// R1-Schutz wirkt NUR auf Konzern-Aggregat-Summen (Holding-Hero).
// HOLDING_FIRMA_WHITELIST = alle vier Firmen, CONSOLIDATION_FIRMEN =
// nur die drei, die im Konzern-Aggregat erscheinen duerfen.

export const HOLDING_FIRMA_WHITELIST = [
  "drainx",
  "gundk",
  "xholding",
  "infrax",
] as const;

export const CONSOLIDATION_FIRMEN = [
  "drainx",
  "gundk",
  "xholding",
] as const;

export type HoldingFirma = (typeof HOLDING_FIRMA_WHITELIST)[number];
export type ConsolidationFirma = (typeof CONSOLIDATION_FIRMEN)[number];

export const FIRMA_DISPLAY: Record<HoldingFirma, string> = {
  drainx: "DrainX",
  gundk: "G+K",
  xholding: "X-Holding UG",
  infrax: "InfraX",
};

export function isHoldingFirma(v: unknown): v is HoldingFirma {
  return (
    typeof v === "string" &&
    (HOLDING_FIRMA_WHITELIST as readonly string[]).includes(v)
  );
}

/** Filtert InfraX aus Konzern-Aggregat-Daten (Holding-Hero, Konsolidierung).
 * Single-Firma-Endpoints wie /firmen/infrax filtern NICHT.
 */
export function isConsolidationFirma(v: unknown): v is ConsolidationFirma {
  return (
    typeof v === "string" &&
    (CONSOLIDATION_FIRMEN as readonly string[]).includes(v)
  );
}

export function filterConsolidationFirmen<T extends { firma?: string }>(
  items: T[],
): T[] {
  return items.filter(
    (it) => it.firma === undefined || isConsolidationFirma(it.firma),
  );
}
